// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-item":"breadcrumb-item_breadcrumb-item__twBtx","home":"breadcrumb-item_home__ok2Z9","dots":"breadcrumb-item_dots__Rz8Ns","popover":"breadcrumb-item_popover__53_zA"};